// W66.G — Org Map shared types

export type RoleInDeal =
  | "Decision Maker"
  | "Economic Buyer"
  | "Champion"
  | "Influencer"
  | "User"
  | "Blocker"
  | "Unknown";

export type Sentiment = "Supporter" | "Neutral" | "Skeptic" | "Blocker" | "Unknown";

export interface OrgNode {
  id: number;
  tenant_id: number;
  account_id: number;
  contact_id: number | null;
  display_name: string;
  title: string | null;
  role_in_deal: RoleInDeal | null;
  power_level: number | null;
  sentiment: Sentiment | null;
  reports_to_node_id: number | null;
  notes: string | null;
  created_at: string;
  updated_at: string;
}

export interface OrgEdge {
  id: number;
  tenant_id: number;
  account_id: number;
  from_node_id: number;
  to_node_id: number;
  relationship: "blocks" | "aligns_with" | "mentors" | "reports_to" | "rivals";
  notes: string | null;
  created_at: string;
}

export const ROLES: RoleInDeal[] = [
  "Decision Maker",
  "Economic Buyer",
  "Champion",
  "Influencer",
  "User",
  "Blocker",
  "Unknown",
];

export const SENTIMENTS: Sentiment[] = [
  "Supporter",
  "Neutral",
  "Skeptic",
  "Blocker",
  "Unknown",
];

// Role pill styles — role-specific colors per spec
export function rolePillClass(role: RoleInDeal | null): string {
  switch (role) {
    case "Decision Maker":
      return "border border-rose-600 text-rose-700 bg-rose-50";
    case "Economic Buyer":
      return "border border-rose-600 text-rose-700 bg-rose-50";
    case "Champion":
      return "border border-emerald-600 text-emerald-700 bg-emerald-50";
    case "Influencer":
      return "border border-orange-500 text-orange-700 bg-orange-50";
    case "User":
      return "border border-gray-400 text-gray-600 bg-gray-50";
    case "Blocker":
      return "bg-rose-600 text-white border border-rose-600";
    default:
      return "border border-gray-300 text-gray-500 bg-gray-50";
  }
}

// Sentiment bar color
export function sentimentColor(s: Sentiment | null): string {
  switch (s) {
    case "Supporter":
      return "bg-emerald-500";
    case "Neutral":
      return "bg-gray-400";
    case "Skeptic":
      return "bg-orange-400";
    case "Blocker":
      return "bg-rose-600";
    default:
      return "bg-gray-300";
  }
}
